import { steps } from "./util/constants";
import { getIsEmbedded } from "./util/params";

export const getDefaultStep = () =>
  getIsEmbedded() ? steps.loading : steps.init;
